import { render } from "./ManageIntegrations.vue?vue&type=template&id=5f399bc6"
import script from "./ManageIntegrations.vue?vue&type=script&lang=js"
export * from "./ManageIntegrations.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__